import { MemberInterview } from './MemberInterview';

export default MemberInterview;